import React from "react";
import { Link } from "react-router-dom";
import "./Services.css";

function Services() {
    const servicesList = [
        {
            icon: "🚗",
            title: "Van Sales",
            description: "We offer a curated selection of high-quality, pre-owned vans. Each vehicle is thoroughly inspected to ensure reliability and performance for your needs.",
            link: "https://www.ebay.co.uk/str/kriscars4ltd",
            cta: "Vans for sale"
        },
        {
            icon: "🛠️",
            title: "Repairs & Maintenance",
            description: "Our expert mechanics handle everything from routine servicing to complex engine diagnostics and repairs. We use top-grade parts to keep you on the road.",
            link: "/contact",
            cta: "Book a Repair"
        },
        {
            icon: "🚙",
            title: "Car & Van Parts",
            description: "Looking for a specific part? We have a wide inventory of tested, quality used parts. Visit our official eBay store to browse and buy with confidence.",
            externalLink: "https://www.ebay.co.uk/str/kriscars4ltd",
            cta: "Visit eBay Store"
        }
    ];

    return (
        <div className="services-page">
            <header className="services-header">
                <div className="header-content">
                    <h1>Our Services</h1>
                    <p>Comprehensive solutions to keep you moving.</p>
                </div>
            </header>

            <main className="services-main">
                <div className="services-grid">
                    {servicesList.map((service, index) => (
                        <div className="service-card" key={index}>
                            <div className="service-icon">{service.icon}</div>
                            <h2 className="service-title">{service.title}</h2>
                            <p className="service-description">{service.description}</p>
                            <div className="service-cta">
                                {service.externalLink ? (
                                    <a href={service.externalLink} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                                        {service.cta}
                                    </a>
                                ) : (
                                    <Link to={service.link} className="btn btn-secondary">
                                        {service.cta}
                                    </Link>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </main>
        </div>
    );
}

export default Services;